import script from "./consultInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./consultInfoList.vue?vue&type=script&setup=true&lang=js"

import "./consultInfoList.vue?vue&type=style&index=0&id=9b8c5006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b8c5006"]])

export default __exports__